/* tslint:disable */
/* eslint-disable */
/**
 * Radianse Device History APP - .Net 6
 * <b>Build:</b>Radianse.App.DeviceHistory_main_2023.9.11.1
 *
 * The version of the OpenAPI document: UserApi
 * Contact: support@radianse.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Configuration } from "./configuration";
import globalAxios, {
  AxiosPromise,
  AxiosInstance,
  AxiosRequestConfig,
} from "axios";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from "./common";
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from "./base";

/**
 *
 * @export
 * @interface IDailyTotalsSummary
 */
export interface IDailyTotalsSummary {
  /**
   * The total number of minutes the equipment was active during the period.
   * @type {string}
   * @memberof IDailyTotalsSummary
   */
  totalTimeForPeriod?: string;
  /**
   *
   * @type {Array<IEquipmentDailyTotals>}
   * @memberof IDailyTotalsSummary
   */
  dailyTotals?: Array<IEquipmentDailyTotals>;
}
/**
 *
 * @export
 * @interface IDailyTotalsSummaryIRadianseResult
 */
export interface IDailyTotalsSummaryIRadianseResult {
  /**
   *
   * @type {number}
   * @memberof IDailyTotalsSummaryIRadianseResult
   */
  count?: number | null;
  /**
   *
   * @type {IDailyTotalsSummary}
   * @memberof IDailyTotalsSummaryIRadianseResult
   */
  data?: IDailyTotalsSummary;
  /**
   *
   * @type {string}
   * @memberof IDailyTotalsSummaryIRadianseResult
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IDailyTotalsSummaryIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IDailyTotalsSummaryIRadianseResult
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IDailyTotalsSummaryIRadianseResult
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IDailyTotalsSummaryIRadianseResult
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IDailyTotalsSummaryIRadianseResult
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IDailyTotalsSummaryIRadianseResult
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IDailyTotalsSummaryIRadianseResult
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IDailyTotalsSummaryIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IEquipmentDailyTotals
 */
export interface IEquipmentDailyTotals {
  /**
   *
   * @type {string}
   * @memberof IEquipmentDailyTotals
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof IEquipmentDailyTotals
   */
  partitionKey: string;
  /**
   *
   * @type {string}
   * @memberof IEquipmentDailyTotals
   */
  category?: string;
  /**
   *
   * @type {string}
   * @memberof IEquipmentDailyTotals
   */
  subCategory?: string;
  /**
   *
   * @type {string}
   * @memberof IEquipmentDailyTotals
   */
  customerId: string;
  /**
   *
   * @type {string}
   * @memberof IEquipmentDailyTotals
   */
  equipmentId: string;
  /**
   *
   * @type {string}
   * @memberof IEquipmentDailyTotals
   */
  date: string;
  /**
   *
   * @type {string}
   * @memberof IEquipmentDailyTotals
   */
  totalTime: string;
}
/**
 * Called by Schedule to update the total minutes the device was active.
 * @export
 * @interface IEquipmentDailyTotalsDto
 */
export interface IEquipmentDailyTotalsDto {
  /**
   * The Guid id of the Equipment used.
   * @type {string}
   * @memberof IEquipmentDailyTotalsDto
   */
  equipmentId: string;
  /**
   * The date the activity occurred on.
   * @type {string}
   * @memberof IEquipmentDailyTotalsDto
   */
  date: string;
  /**
   * A timespan showing the amount of time the equipment ran for.
   * @type {string}
   * @memberof IEquipmentDailyTotalsDto
   */
  totalTime: string;
}
/**
 *
 * @export
 * @interface IEquipmentDailyTotalsDtoIRadianseResult
 */
export interface IEquipmentDailyTotalsDtoIRadianseResult {
  /**
   *
   * @type {number}
   * @memberof IEquipmentDailyTotalsDtoIRadianseResult
   */
  count?: number | null;
  /**
   *
   * @type {IEquipmentDailyTotalsDto}
   * @memberof IEquipmentDailyTotalsDtoIRadianseResult
   */
  data?: IEquipmentDailyTotalsDto;
  /**
   *
   * @type {string}
   * @memberof IEquipmentDailyTotalsDtoIRadianseResult
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IEquipmentDailyTotalsDtoIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IEquipmentDailyTotalsDtoIRadianseResult
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IEquipmentDailyTotalsDtoIRadianseResult
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IEquipmentDailyTotalsDtoIRadianseResult
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IEquipmentDailyTotalsDtoIRadianseResult
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IEquipmentDailyTotalsDtoIRadianseResult
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IEquipmentDailyTotalsDtoIRadianseResult
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IEquipmentDailyTotalsDtoIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IEquipmentDailyTotalsDtoIRadianseResultSuccess
 */
export interface IEquipmentDailyTotalsDtoIRadianseResultSuccess {
  /**
   *
   * @type {number}
   * @memberof IEquipmentDailyTotalsDtoIRadianseResultSuccess
   */
  count?: number | null;
  /**
   *
   * @type {IEquipmentDailyTotalsDto}
   * @memberof IEquipmentDailyTotalsDtoIRadianseResultSuccess
   */
  data: IEquipmentDailyTotalsDto;
  /**
   *
   * @type {string}
   * @memberof IEquipmentDailyTotalsDtoIRadianseResultSuccess
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IEquipmentDailyTotalsDtoIRadianseResultSuccess
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IEquipmentDailyTotalsDtoIRadianseResultSuccess
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IEquipmentDailyTotalsDtoIRadianseResultSuccess
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IEquipmentDailyTotalsDtoIRadianseResultSuccess
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IEquipmentDailyTotalsDtoIRadianseResultSuccess
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IEquipmentDailyTotalsDtoIRadianseResultSuccess
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IEquipmentDailyTotalsDtoIRadianseResultSuccess
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IEquipmentDailyTotalsDtoIRadianseResultSuccess
   */
  continuationToken?: string | null;
}
/**
 * The state of an Equipment to be stored by DeviceHistory.
 * @export
 * @interface IEquipmentState
 */
export interface IEquipmentState {
  /**
   * The Equipment\'s ID.
   * @type {string}
   * @memberof IEquipmentState
   */
  id?: string;
  /**
   * The Tenant ID.
   * @type {string}
   * @memberof IEquipmentState
   */
  partitionKey?: string;
  /**
   * The category. Always \"History\"
   * @type {string}
   * @memberof IEquipmentState
   */
  category?: string;
  /**
   * The sub-category. Always \"EquipmentState\"
   * @type {string}
   * @memberof IEquipmentState
   */
  subCategory?: string;
  /**
   * The Customer ID
   * @type {string}
   * @memberof IEquipmentState
   */
  customerId?: string;
  /**
   * The Id GUID of the equipment.
   * @type {string}
   * @memberof IEquipmentState
   */
  equipmentId?: string;
  /**
   * The Schedule\'s ID.
   * @type {string}
   * @memberof IEquipmentState
   */
  scheduleId?: string;
  /**
   * The event that caused the equipment\'s state to change.
   * @type {string}
   * @memberof IEquipmentState
   */
  deviceEvent?: string | null;
  /**
   * The current state of the Equipment.
   * @type {string}
   * @memberof IEquipmentState
   */
  deviceStatus?: string;
  /**
   * The time.
   * @type {string}
   * @memberof IEquipmentState
   */
  time?: string;
  /**
   * The time to delay before starting the device, in minutes.
   * @type {number}
   * @memberof IEquipmentState
   */
  delay?: number;
  /**
   * The remaining time for delay.
   * @type {number}
   * @memberof IEquipmentState
   */
  delayRequested?: number;
  /**
   * The time to run the device for, in minutes.
   * @type {number}
   * @memberof IEquipmentState
   */
  duration?: number;
  /**
   * The remaining run time for the device.
   * @type {number}
   * @memberof IEquipmentState
   */
  durationRequested?: number;
  /**
   * The requested time to keep the device in Dirty state.
   * @type {number}
   * @memberof IEquipmentState
   */
  dirty?: number;
  /**
   * The remaining time for dirty.
   * @type {number}
   * @memberof IEquipmentState
   */
  dirtyRequested?: number;
  /**
   * True if the device is connected, false if it is not.
   * @type {boolean}
   * @memberof IEquipmentState
   */
  connected?: boolean;
  /**
   * True if the device is in maintenance state.
   * @type {boolean}
   * @memberof IEquipmentState
   */
  isInMaintenance?: boolean;
  /**
   * A message to pass along. Often used for errors.
   * @type {string}
   * @memberof IEquipmentState
   */
  message?: string | null;
  /**
   * Device parameters that doesn\'t change often.
   * @type {{ [key: string]: any; }}
   * @memberof IEquipmentState
   */
  options?: { [key: string]: any };
  /**
   * The number of seconds the device has been connected.
   * @type {number}
   * @memberof IEquipmentState
   */
  secondsConnected?: number;
  /**
   * The number of seconds the device has been disconnected.
   * @type {number}
   * @memberof IEquipmentState
   */
  secondsDisconnected?: number;
  /**
   * Any metadata attributed to the state, including Member.
   * @type {{ [key: string]: IMetaDataInfo; }}
   * @memberof IEquipmentState
   */
  metaData?: { [key: string]: IMetaDataInfo };
}
/**
 * Contains all the state info sent from a local service.
 * @export
 * @interface IEquipmentStateDto
 */
export interface IEquipmentStateDto {
  /**
   * The Account Number. Could be a club code.
   * @type {string}
   * @memberof IEquipmentStateDto
   */
  accountNumber: string;
  /**
   * The Id GUID of the equipment.
   * @type {string}
   * @memberof IEquipmentStateDto
   */
  equipmentId: string;
  /**
   * Specifies the connector that sent the message.
   * @type {string}
   * @memberof IEquipmentStateDto
   */
  connectorId: string;
  /**
   * Specifies the device in connector terms.
   * @type {string}
   * @memberof IEquipmentStateDto
   */
  deviceId: string;
  /**
   * The device event
   * @type {string}
   * @memberof IEquipmentStateDto
   */
  status?: string | null;
  /**
   * The time the state event occurred.
   * @type {string}
   * @memberof IEquipmentStateDto
   */
  time: string;
  /**
   * Number of minutes to delay before activating the device.
   * @type {number}
   * @memberof IEquipmentStateDto
   */
  delay: number;
  /**
   * Total number of minutes to run the device.
   * @type {number}
   * @memberof IEquipmentStateDto
   */
  duration: number;
  /**
   * The guid Id of the Schedule associated with the Equipment.
   * @type {string}
   * @memberof IEquipmentStateDto
   */
  scheduleId?: string;
  /**
   * The error message associated with the event, if any.
   * @type {string}
   * @memberof IEquipmentStateDto
   */
  message?: string | null;
}
/**
 *
 * @export
 * @interface IEquipmentStateIRadianseResult
 */
export interface IEquipmentStateIRadianseResult {
  /**
   *
   * @type {number}
   * @memberof IEquipmentStateIRadianseResult
   */
  count?: number | null;
  /**
   *
   * @type {IEquipmentState}
   * @memberof IEquipmentStateIRadianseResult
   */
  data?: IEquipmentState;
  /**
   *
   * @type {string}
   * @memberof IEquipmentStateIRadianseResult
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IEquipmentStateIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IEquipmentStateIRadianseResult
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IEquipmentStateIRadianseResult
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IEquipmentStateIRadianseResult
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IEquipmentStateIRadianseResult
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IEquipmentStateIRadianseResult
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IEquipmentStateIRadianseResult
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IEquipmentStateIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IEquipmentStateIRadianseResultSuccess
 */
export interface IEquipmentStateIRadianseResultSuccess {
  /**
   *
   * @type {number}
   * @memberof IEquipmentStateIRadianseResultSuccess
   */
  count?: number | null;
  /**
   *
   * @type {IEquipmentState}
   * @memberof IEquipmentStateIRadianseResultSuccess
   */
  data: IEquipmentState;
  /**
   *
   * @type {string}
   * @memberof IEquipmentStateIRadianseResultSuccess
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IEquipmentStateIRadianseResultSuccess
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IEquipmentStateIRadianseResultSuccess
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IEquipmentStateIRadianseResultSuccess
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IEquipmentStateIRadianseResultSuccess
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IEquipmentStateIRadianseResultSuccess
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IEquipmentStateIRadianseResultSuccess
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IEquipmentStateIRadianseResultSuccess
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IEquipmentStateIRadianseResultSuccess
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IEquipmentStateListIRadianseResult
 */
export interface IEquipmentStateListIRadianseResult {
  /**
   *
   * @type {number}
   * @memberof IEquipmentStateListIRadianseResult
   */
  count?: number | null;
  /**
   *
   * @type {Array<IEquipmentState>}
   * @memberof IEquipmentStateListIRadianseResult
   */
  data?: Array<IEquipmentState> | null;
  /**
   *
   * @type {string}
   * @memberof IEquipmentStateListIRadianseResult
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IEquipmentStateListIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IEquipmentStateListIRadianseResult
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IEquipmentStateListIRadianseResult
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IEquipmentStateListIRadianseResult
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IEquipmentStateListIRadianseResult
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IEquipmentStateListIRadianseResult
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IEquipmentStateListIRadianseResult
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IEquipmentStateListIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IEquipmentStateListIRadianseResultSuccess
 */
export interface IEquipmentStateListIRadianseResultSuccess {
  /**
   *
   * @type {number}
   * @memberof IEquipmentStateListIRadianseResultSuccess
   */
  count?: number | null;
  /**
   *
   * @type {Array<IEquipmentState>}
   * @memberof IEquipmentStateListIRadianseResultSuccess
   */
  data: Array<IEquipmentState>;
  /**
   *
   * @type {string}
   * @memberof IEquipmentStateListIRadianseResultSuccess
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IEquipmentStateListIRadianseResultSuccess
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IEquipmentStateListIRadianseResultSuccess
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IEquipmentStateListIRadianseResultSuccess
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IEquipmentStateListIRadianseResultSuccess
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IEquipmentStateListIRadianseResultSuccess
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IEquipmentStateListIRadianseResultSuccess
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IEquipmentStateListIRadianseResultSuccess
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IEquipmentStateListIRadianseResultSuccess
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IIRadianseRequestContext
 */
export interface IIRadianseRequestContext {
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  clientAccessToken?: string;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  acceptLanguage?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  ipAddress?: string;
  /**
   *
   * @type {boolean}
   * @memberof IIRadianseRequestContext
   */
  isUserRequest?: boolean;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  scopeToCustomerId?: string;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  scopeToGroupId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  scopeToTenantId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  userAccessToken?: string;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  detail?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  identityProfileId?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  clientRoles?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  customerRoles?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  groupRoles?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  tenantRoles?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  customerPermissions?: Array<string> | null;
  /**
   *
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  groupPermissions?: Array<string> | null;
  /**
   *
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  tenantPermissions?: Array<string> | null;
}
/**
 *
 * @export
 * @interface IMetaDataInfo
 */
export interface IMetaDataInfo {
  /**
   * Dynamic data
   * @type {any}
   * @memberof IMetaDataInfo
   */
  data?: any;
}

/**
 * EquipmentHistoryUserApiApi - axios parameter creator
 * @export
 */
export const EquipmentHistoryUserApiApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Permission: equipmenthistory_read
     * @summary Gets the current equipment state information for all the Equipment of the given connector.
     * @param {Array<string>} [equipmentIds] The id of the connector to get equipment states for.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiEquipmentHistoryCurrentGet: async (
      equipmentIds?: Array<string>,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/EquipmentHistory/Current`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (equipmentIds) {
        localVarQueryParameter["equipmentIds"] = equipmentIds;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: equipmenthistory_read
     * @summary Gets the current equipment state information for the given EquipmentId.
     * @param {string} id The id of the equipment to get history on.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiEquipmentHistoryCurrentIdGet: async (
      id: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("userApiEquipmentHistoryCurrentIdGet", "id", id);
      const localVarPath = `/UserApi/EquipmentHistory/Current/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: equipmenthistory_create
     * @summary Posts new equipment state.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IEquipmentStateDto} [iEquipmentStateDto] The state of the equipment.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiEquipmentHistoryPost: async (
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iEquipmentStateDto?: IEquipmentStateDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/EquipmentHistory`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iEquipmentStateDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: equipmenthistory_read
     * @summary Gets the equipment state information for the given range of dates.  If no date is given for endTime, it assumes an endTime of now.
     * @param {string} startTime The date/time marking the start of the range. This is in UTC only.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [endTime] The date/time marking the end of the range, or null if the end is now. This is in UTC only.
     * @param {string} [equipmentId] The id of the equipment to get history on.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiEquipmentHistoryRangeStartTimeGet: async (
      startTime: string,
      tenantId?: string,
      endTime?: string,
      equipmentId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'startTime' is not null or undefined
      assertParamExists(
        "userApiEquipmentHistoryRangeStartTimeGet",
        "startTime",
        startTime
      );
      const localVarPath =
        `/UserApi/EquipmentHistory/Range/{startTime}`.replace(
          `{${"startTime"}}`,
          encodeURIComponent(String(startTime))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (endTime !== undefined) {
        localVarQueryParameter["endTime"] =
          (endTime as any) instanceof Date
            ? (endTime as any).toISOString()
            : endTime;
      }

      if (equipmentId !== undefined) {
        localVarQueryParameter["equipmentId"] = equipmentId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: equipmenthistory_read
     * @summary Gets the usage data for the past X number of days for the given device.  X is the value passed in the numDays field.
     * @param {string} equipmentId The GUID of the Equipment that was used.
     * @param {number} numDays The number days before now to get usage from.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiEquipmentHistoryTotalsEquipmentIdNumDaysGet: async (
      equipmentId: string,
      numDays: number,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'equipmentId' is not null or undefined
      assertParamExists(
        "userApiEquipmentHistoryTotalsEquipmentIdNumDaysGet",
        "equipmentId",
        equipmentId
      );
      // verify required parameter 'numDays' is not null or undefined
      assertParamExists(
        "userApiEquipmentHistoryTotalsEquipmentIdNumDaysGet",
        "numDays",
        numDays
      );
      const localVarPath =
        `/UserApi/EquipmentHistory/totals/{equipmentId}/{numDays}`
          .replace(
            `{${"equipmentId"}}`,
            encodeURIComponent(String(equipmentId))
          )
          .replace(`{${"numDays"}}`, encodeURIComponent(String(numDays)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: equipmenthistory_create
     * @summary Posts new totals to the daily totals.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IEquipmentDailyTotalsDto} [iEquipmentDailyTotalsDto] The data to post.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiEquipmentHistoryTotalsPost: async (
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iEquipmentDailyTotalsDto?: IEquipmentDailyTotalsDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/EquipmentHistory/totals`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iEquipmentDailyTotalsDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * EquipmentHistoryUserApiApi - functional programming interface
 * @export
 */
export const EquipmentHistoryUserApiApiFp = function (
  configuration?: Configuration
) {
  const localVarAxiosParamCreator =
    EquipmentHistoryUserApiApiAxiosParamCreator(configuration);
  return {
    /**
     * Permission: equipmenthistory_read
     * @summary Gets the current equipment state information for all the Equipment of the given connector.
     * @param {Array<string>} [equipmentIds] The id of the connector to get equipment states for.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiEquipmentHistoryCurrentGet(
      equipmentIds?: Array<string>,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IEquipmentStateListIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiEquipmentHistoryCurrentGet(
          equipmentIds,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: equipmenthistory_read
     * @summary Gets the current equipment state information for the given EquipmentId.
     * @param {string} id The id of the equipment to get history on.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiEquipmentHistoryCurrentIdGet(
      id: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IEquipmentStateIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiEquipmentHistoryCurrentIdGet(
          id,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: equipmenthistory_create
     * @summary Posts new equipment state.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IEquipmentStateDto} [iEquipmentStateDto] The state of the equipment.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiEquipmentHistoryPost(
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iEquipmentStateDto?: IEquipmentStateDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IEquipmentStateIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiEquipmentHistoryPost(
          tenantId,
          apiVersion,
          acceptLanguage,
          iEquipmentStateDto,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: equipmenthistory_read
     * @summary Gets the equipment state information for the given range of dates.  If no date is given for endTime, it assumes an endTime of now.
     * @param {string} startTime The date/time marking the start of the range. This is in UTC only.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [endTime] The date/time marking the end of the range, or null if the end is now. This is in UTC only.
     * @param {string} [equipmentId] The id of the equipment to get history on.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiEquipmentHistoryRangeStartTimeGet(
      startTime: string,
      tenantId?: string,
      endTime?: string,
      equipmentId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IEquipmentStateListIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiEquipmentHistoryRangeStartTimeGet(
          startTime,
          tenantId,
          endTime,
          equipmentId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: equipmenthistory_read
     * @summary Gets the usage data for the past X number of days for the given device.  X is the value passed in the numDays field.
     * @param {string} equipmentId The GUID of the Equipment that was used.
     * @param {number} numDays The number days before now to get usage from.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiEquipmentHistoryTotalsEquipmentIdNumDaysGet(
      equipmentId: string,
      numDays: number,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IEquipmentStateIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiEquipmentHistoryTotalsEquipmentIdNumDaysGet(
          equipmentId,
          numDays,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: equipmenthistory_create
     * @summary Posts new totals to the daily totals.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IEquipmentDailyTotalsDto} [iEquipmentDailyTotalsDto] The data to post.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiEquipmentHistoryTotalsPost(
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iEquipmentDailyTotalsDto?: IEquipmentDailyTotalsDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IEquipmentDailyTotalsDtoIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiEquipmentHistoryTotalsPost(
          tenantId,
          apiVersion,
          acceptLanguage,
          iEquipmentDailyTotalsDto,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * EquipmentHistoryUserApiApi - factory interface
 * @export
 */
export const EquipmentHistoryUserApiApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = EquipmentHistoryUserApiApiFp(configuration);
  return {
    /**
     * Permission: equipmenthistory_read
     * @summary Gets the current equipment state information for all the Equipment of the given connector.
     * @param {Array<string>} [equipmentIds] The id of the connector to get equipment states for.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiEquipmentHistoryCurrentGet(
      equipmentIds?: Array<string>,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IEquipmentStateListIRadianseResultSuccess> {
      return localVarFp
        .userApiEquipmentHistoryCurrentGet(
          equipmentIds,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: equipmenthistory_read
     * @summary Gets the current equipment state information for the given EquipmentId.
     * @param {string} id The id of the equipment to get history on.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiEquipmentHistoryCurrentIdGet(
      id: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IEquipmentStateIRadianseResultSuccess> {
      return localVarFp
        .userApiEquipmentHistoryCurrentIdGet(
          id,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: equipmenthistory_create
     * @summary Posts new equipment state.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IEquipmentStateDto} [iEquipmentStateDto] The state of the equipment.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiEquipmentHistoryPost(
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iEquipmentStateDto?: IEquipmentStateDto,
      options?: any
    ): AxiosPromise<IEquipmentStateIRadianseResultSuccess> {
      return localVarFp
        .userApiEquipmentHistoryPost(
          tenantId,
          apiVersion,
          acceptLanguage,
          iEquipmentStateDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: equipmenthistory_read
     * @summary Gets the equipment state information for the given range of dates.  If no date is given for endTime, it assumes an endTime of now.
     * @param {string} startTime The date/time marking the start of the range. This is in UTC only.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [endTime] The date/time marking the end of the range, or null if the end is now. This is in UTC only.
     * @param {string} [equipmentId] The id of the equipment to get history on.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiEquipmentHistoryRangeStartTimeGet(
      startTime: string,
      tenantId?: string,
      endTime?: string,
      equipmentId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IEquipmentStateListIRadianseResultSuccess> {
      return localVarFp
        .userApiEquipmentHistoryRangeStartTimeGet(
          startTime,
          tenantId,
          endTime,
          equipmentId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: equipmenthistory_read
     * @summary Gets the usage data for the past X number of days for the given device.  X is the value passed in the numDays field.
     * @param {string} equipmentId The GUID of the Equipment that was used.
     * @param {number} numDays The number days before now to get usage from.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiEquipmentHistoryTotalsEquipmentIdNumDaysGet(
      equipmentId: string,
      numDays: number,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IEquipmentStateIRadianseResultSuccess> {
      return localVarFp
        .userApiEquipmentHistoryTotalsEquipmentIdNumDaysGet(
          equipmentId,
          numDays,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: equipmenthistory_create
     * @summary Posts new totals to the daily totals.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IEquipmentDailyTotalsDto} [iEquipmentDailyTotalsDto] The data to post.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiEquipmentHistoryTotalsPost(
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iEquipmentDailyTotalsDto?: IEquipmentDailyTotalsDto,
      options?: any
    ): AxiosPromise<IEquipmentDailyTotalsDtoIRadianseResultSuccess> {
      return localVarFp
        .userApiEquipmentHistoryTotalsPost(
          tenantId,
          apiVersion,
          acceptLanguage,
          iEquipmentDailyTotalsDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * EquipmentHistoryUserApiApi - object-oriented interface
 * @export
 * @class EquipmentHistoryUserApiApi
 * @extends {BaseAPI}
 */
export class EquipmentHistoryUserApiApi extends BaseAPI {
  /**
   * Permission: equipmenthistory_read
   * @summary Gets the current equipment state information for all the Equipment of the given connector.
   * @param {Array<string>} [equipmentIds] The id of the connector to get equipment states for.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EquipmentHistoryUserApiApi
   */
  public userApiEquipmentHistoryCurrentGet(
    equipmentIds?: Array<string>,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return EquipmentHistoryUserApiApiFp(this.configuration)
      .userApiEquipmentHistoryCurrentGet(
        equipmentIds,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: equipmenthistory_read
   * @summary Gets the current equipment state information for the given EquipmentId.
   * @param {string} id The id of the equipment to get history on.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EquipmentHistoryUserApiApi
   */
  public userApiEquipmentHistoryCurrentIdGet(
    id: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return EquipmentHistoryUserApiApiFp(this.configuration)
      .userApiEquipmentHistoryCurrentIdGet(
        id,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: equipmenthistory_create
   * @summary Posts new equipment state.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {IEquipmentStateDto} [iEquipmentStateDto] The state of the equipment.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EquipmentHistoryUserApiApi
   */
  public userApiEquipmentHistoryPost(
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iEquipmentStateDto?: IEquipmentStateDto,
    options?: AxiosRequestConfig
  ) {
    return EquipmentHistoryUserApiApiFp(this.configuration)
      .userApiEquipmentHistoryPost(
        tenantId,
        apiVersion,
        acceptLanguage,
        iEquipmentStateDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: equipmenthistory_read
   * @summary Gets the equipment state information for the given range of dates.  If no date is given for endTime, it assumes an endTime of now.
   * @param {string} startTime The date/time marking the start of the range. This is in UTC only.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [endTime] The date/time marking the end of the range, or null if the end is now. This is in UTC only.
   * @param {string} [equipmentId] The id of the equipment to get history on.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EquipmentHistoryUserApiApi
   */
  public userApiEquipmentHistoryRangeStartTimeGet(
    startTime: string,
    tenantId?: string,
    endTime?: string,
    equipmentId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return EquipmentHistoryUserApiApiFp(this.configuration)
      .userApiEquipmentHistoryRangeStartTimeGet(
        startTime,
        tenantId,
        endTime,
        equipmentId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: equipmenthistory_read
   * @summary Gets the usage data for the past X number of days for the given device.  X is the value passed in the numDays field.
   * @param {string} equipmentId The GUID of the Equipment that was used.
   * @param {number} numDays The number days before now to get usage from.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EquipmentHistoryUserApiApi
   */
  public userApiEquipmentHistoryTotalsEquipmentIdNumDaysGet(
    equipmentId: string,
    numDays: number,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return EquipmentHistoryUserApiApiFp(this.configuration)
      .userApiEquipmentHistoryTotalsEquipmentIdNumDaysGet(
        equipmentId,
        numDays,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: equipmenthistory_create
   * @summary Posts new totals to the daily totals.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {IEquipmentDailyTotalsDto} [iEquipmentDailyTotalsDto] The data to post.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EquipmentHistoryUserApiApi
   */
  public userApiEquipmentHistoryTotalsPost(
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iEquipmentDailyTotalsDto?: IEquipmentDailyTotalsDto,
    options?: AxiosRequestConfig
  ) {
    return EquipmentHistoryUserApiApiFp(this.configuration)
      .userApiEquipmentHistoryTotalsPost(
        tenantId,
        apiVersion,
        acceptLanguage,
        iEquipmentDailyTotalsDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * UserApiRequestContextApi - axios parameter creator
 * @export
 */
export const UserApiRequestContextApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRequestcontextGet: async (
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/requestcontext`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * UserApiRequestContextApi - functional programming interface
 * @export
 */
export const UserApiRequestContextApiFp = function (
  configuration?: Configuration
) {
  const localVarAxiosParamCreator =
    UserApiRequestContextApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiRequestcontextGet(
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IIRadianseRequestContext>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiRequestcontextGet(
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * UserApiRequestContextApi - factory interface
 * @export
 */
export const UserApiRequestContextApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = UserApiRequestContextApiFp(configuration);
  return {
    /**
     *
     * @summary
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRequestcontextGet(
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IIRadianseRequestContext> {
      return localVarFp
        .userApiRequestcontextGet(apiVersion, acceptLanguage, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * UserApiRequestContextApi - object-oriented interface
 * @export
 * @class UserApiRequestContextApi
 * @extends {BaseAPI}
 */
export class UserApiRequestContextApi extends BaseAPI {
  /**
   *
   * @summary
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApiRequestContextApi
   */
  public userApiRequestcontextGet(
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return UserApiRequestContextApiFp(this.configuration)
      .userApiRequestcontextGet(apiVersion, acceptLanguage, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
